function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getClassName } from '../utils/get-class-name';
var Container = styled.label.withConfig({
  displayName: "Label__Container"
})(["margin-right:auto;margin-left:0;cursor:", ";"], function (props) {
  return props.disabled ? 'text' : 'pointer';
});
var defaultProps = {
  disabled: false
};

var Label = function Label(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      className = _defaultProps$props.className,
      disabled = _defaultProps$props.disabled,
      labelText = _defaultProps$props.labelText,
      sharedId = _defaultProps$props.sharedId; // overlay the defaultProps and passed in props in logical order and spread to constant values


  return _jsx(Container, {
    className: getClassName(className, null, 'styled-label'),
    disabled: disabled,
    htmlFor: sharedId,
    children: labelText
  });
};

Label.defaultProps = defaultProps;
var LabelTest = {
  Container: Container
};
export { Label, LabelTest };
export default Label;